<button class="burger-icon" (click)="onIconClick()">
  <mat-icon fontSet="material-icons-round">menu_rounded</mat-icon>
</button>
